import { useCallback, useEffect, useState } from "react";
import { resetScrollPosition } from "../utils/scrollReset";
import { normalizePath } from "../utils/routing";

export function useRoute() {
  const [path, setPath] = useState(() => normalizePath(window.location.pathname));

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const handlePopState = () => setPath(normalizePath(window.location.pathname));
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const navigate = useCallback((nextPath) => {
    const targetPath = normalizePath(nextPath);
    if (targetPath === normalizePath(window.location.pathname)) {
      resetScrollPosition();
      return;
    }

    window.history.pushState({}, "", targetPath);
    setPath(targetPath);
  }, []);

  return { path, navigate };
}
